import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

const COLS = [
  { title: "Shop", links: [["Shop All", "/shop"], ["New Arrivals", "/shop?new_arrival=true"], ["Handbags", "/shop?category=Handbags"], ["Brands", "/brands"]] },
  { title: "House", links: [["About", "/about"], ["Authentication", "/authentication"], ["Contact", "/contact"], ["FAQ", "/faq"]] },
  { title: "Support", links: [["Shipping", "/legal/shipping_policy"], ["Returns", "/legal/returns"], ["Privacy Policy", "/legal/privacy"], ["Terms & Conditions", "/legal/terms"]] },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/newsletter", { email }); toast.success("Thank you — you're on the list."); setEmail(""); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  return (
    <footer className="bg-espresso text-linen/80 mt-24">
      <div className="luxy-container py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="font-serif text-2xl tracking-[0.3em] text-ivory">LUXYREIGN</div>
            <p className="mt-4 text-sm leading-relaxed max-w-xs text-linen/60">
              Curated pre-owned luxury handbags and accessories, selected for those who appreciate enduring style.
            </p>
            <form onSubmit={submit} className="mt-8 max-w-sm">
              <label className="eyebrow text-linen/50">Join the archive</label>
              <div className="flex mt-3 border-b border-linen/30 focus-within:border-champagne transition-colors">
                <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
                  data-testid="newsletter-email-input" placeholder="Your email address"
                  className="bg-transparent flex-1 py-2 text-sm outline-none text-ivory placeholder:text-linen/40" />
                <button type="submit" data-testid="newsletter-submit-button"
                  className="text-[11px] uppercase tracking-[0.2em] text-champagne hover:text-ivory transition-colors pl-4">Subscribe</button>
              </div>
            </form>
          </div>
          <div className="md:col-span-8 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {COLS.map((c) => (
              <div key={c.title}>
                <div className="eyebrow text-linen/50 mb-4">{c.title}</div>
                <ul className="space-y-2.5">
                  {c.links.map(([label, to]) => (
                    <li key={label}><Link to={to} className="text-sm text-linen/70 hover:text-ivory transition-colors">{label}</Link></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-linen/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-linen/50">
          <p>© {new Date().getFullYear()} LUXYREIGN. An independent luxury resale house. Not affiliated with or endorsed by any brand shown.</p>
          <div className="flex gap-5 font-mono tracking-wider">
            <a href="#" className="hover:text-ivory">INSTAGRAM</a>
            <Link to="/legal/cookie" className="hover:text-ivory">COOKIES</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
